import { useCallback, useRef } from 'react';

export const useJobDebounce = (callback, delay = 1000) => {
  const debounceTimerRef = useRef(null);
  
  const debouncedFunction = useCallback((...args) => {
    // Clear existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    
    // Set new timer
    debounceTimerRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  }, [callback, delay]);
  
  return debouncedFunction;
};